import { prop, inject, ComponentEventBus } from "fw";
import autosize from "autosize";

let uniqueId = 0;

@inject
export class TextareaField {
    @prop(null) label: string;
    @prop(null) value: string;
    @prop(null) validation: string;
    @prop(null) placeholder: string;
    @prop("1") rows: string;
    @prop(true) enableAutosize: boolean;
    @prop(false) disabled: boolean;

    private uniqueId = uniqueId++;
    private textareaRef;

    constructor(private ceb: ComponentEventBus) {}

    get id() {
        return `${this.label ? this.label.replace(/\s/g, "") : ""}-taf-${this.uniqueId}`;
    }

    attached() {
        if (this.enableAutosize) {
            autosize(this.textareaRef);
        }
    }

    get pValue() {
        return this.value;
    }

    set pValue(v: string) {
        this.ceb.updateModel(v);
        this.ceb.dispatch("update:value", v);
        this.triggerAutosize();
    }

    triggerAutosize(): void {
        if (this.enableAutosize) {
            console.log("hit?");
            autosize.update(this.textareaRef);
        }
    }
}
